<template>
     <div class="conf-con">
                            <div class="intro-pic">
                              <img src="../../../assets/images/02.jpg" alt="">
                            </div>
                            <p class="intro-tit">中国共产党第二次全国代表大会简介</p>

                            <p class="margin1">１９２２年７月１６日至２３日，中国共产党第二次全国代表大会在上海南成都路辅德里６２５号召开。出席会议的代表共１２名（有一名代表姓名不详），代表全国１９５名党员。这些代表是：中央局委员陈独秀、张国焘、李达，上海的杨明斋，北京的罗章龙，山东的王尽美，湖北的许白昊，湖南的蔡和森，广州的谭平山，中国劳动组合书记部代表李震瀛，中国社会主义青年团临时中央局代表施存统。</p>
                            <p class="margin1">鉴于第一次全国代表大会遭到法国巡捕破坏的教训，“二大”采取了较为严格的保密措施。大会决定以小型的分组会为主，尽量减少全体会议的次数，每次会议都要更换地址。大会共进行了８天，举行了三次全体会议。陈独秀主持大会，并代表中央局向大会作一年来的工作报告；张国焘报告出席远东各国共产党及民族革命团体第一次代表大会的经过以及第一次全国劳动大会的情况；施存统报告社会主义青年团第一次全国代表大会的情况。</p>
                            <p class="margin1">大会根据列宁关于殖民地半殖民地的学说和远东大会的精神，分析了国际形势和中国社会政治经济状况，讨论了党的任务，通过了《中国共产党第二次全国代表大会宣言》、《中国共产党章程》以及《关于“世界大势与中国共产党”的议决案》、《关于“国际帝国主义与中国和中国共产党”的决议案》、《关于“民主的联合战线”的议决案》、《中国共产党加入第三国际决议案》、《关于议会行动议决案》、《关于“工会运动与共产党”的议决案》、《关于少年运动问题的决议案》、《关于妇女运动的决议案》、《关于共产党的组织章程决议案》等９个决议案。大会选举产生了中央执行委员会，陈独秀、邓中夏、张国焘、蔡和森、高君宇为中央执行委员会委员，另选出三名候补执行委员。陈独秀被选为中央执行委员会委员长，蔡和森、张国焘分别负责党的宣传和组织工作。</p>
                            <p class="margin1">大会根据世界革命形势和中国政治经济状况，制定了党的最高纲领和最低纲领。大会宣言指出，中国共产党是中国无产阶级政党，它的目的是要组织无产阶级，用阶级斗争的手段，建立劳农专政的政治，铲除私有财产制度，渐次达到一个共产主义的社会。这是党的最终奋斗目标，是党的最高纲领。为了实现党的最高纲领，大会提出在目前历史条件下的最低纲领，这就是：消除内乱，打倒军阀，建设国内和平；推翻国际帝国主义的压迫，达到中华民族完全独立；统一中国为真正的民主共和国。</p>
                            <p class="margin1">中共二大正确地分析了中国的社会性质，中国革命的性质、对象、动力和前途，指出了中国革命要分两步走，在中国近代史上第一次明确地提出了彻底的反帝反封建的民主革命纲领，为中国各民族人民的革命斗争指明了方向，对中国革命具有重大的深远的意义。 </p>
                        </div>
  </template>
  
  <script>
  export default {
  
  }
  </script>
  
  <style>
  
  </style>